import React from "react";
import { Badge } from "@/components/ui/badge";
import { AlertTriangle } from "lucide-react";

const PRIORITE_STYLES = {
  critique: "bg-red-100 text-red-700 hover:bg-red-100 border-red-200",
  haute: "bg-orange-100 text-orange-700 hover:bg-orange-100 border-orange-200",
  normale: "bg-blue-100 text-blue-700 hover:bg-blue-100 border-blue-200",
  faible: "bg-emerald-100 text-emerald-700 hover:bg-emerald-100 border-emerald-200",
};

const STATUT_STYLES = {
  // Réclamations
  nouvelle: "bg-blue-100 text-blue-700 border-blue-200",
  assignee: "bg-indigo-100 text-indigo-700 border-indigo-200",
  en_traitement: "bg-amber-100 text-amber-800 border-amber-200",
  en_attente_client: "bg-purple-100 text-purple-700 border-purple-200",
  validee: "bg-cyan-100 text-cyan-700 border-cyan-200",
  resolue: "bg-emerald-100 text-emerald-700 border-emerald-200",
  fermee: "bg-slate-200 text-slate-700 border-slate-300",
  rejetee: "bg-red-100 text-red-700 border-red-200",

  // Dossiers
  enregistrement: "bg-blue-100 text-blue-700 border-blue-200",
  affectation: "bg-indigo-100 text-indigo-700 border-indigo-200",
  traitement: "bg-amber-100 text-amber-800 border-amber-200",
  validation: "bg-cyan-100 text-cyan-700 border-cyan-200",
  cloture: "bg-emerald-100 text-emerald-700 border-emerald-200",
  rejete: "bg-slate-200 text-slate-700 border-slate-300",

  // Appels
  nouveau: "bg-blue-100 text-blue-700 border-blue-200",
  en_cours: "bg-amber-100 text-amber-800 border-amber-200",
  termine: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

const LABELS = {
  // priorites
  critique: "Critique",
  haute: "Haute",
  normale: "Normale",
  faible: "Faible",
  // reclamations
  nouvelle: "Nouvelle",
  assignee: "Assignée",
  en_traitement: "En traitement",
  en_attente_client: "En attente client",
  validee: "Validée",
  resolue: "Résolue",
  fermee: "Fermée",
  rejetee: "Rejetée",
  // dossiers
  enregistrement: "Enregistrement",
  affectation: "Affectation",
  traitement: "Traitement",
  validation: "Validation",
  cloture: "Clôturé",
  rejete: "Rejeté",
  // appels
  nouveau: "Nouveau",
  en_cours: "En cours",
  termine: "Terminé",
};

export function PrioriteBadge({ value, ...rest }) {
  return (
    <Badge variant="outline" className={`font-medium ${PRIORITE_STYLES[value] || ""}`} {...rest}>
      {LABELS[value] || value}
    </Badge>
  );
}

export function StatutBadge({ value, ...rest }) {
  return (
    <Badge variant="outline" className={`font-medium ${STATUT_STYLES[value] || ""}`} {...rest}>
      {LABELS[value] || value}
    </Badge>
  );
}

export function EnRetardBadge() {
  return (
    <Badge className="bg-red-600 text-white hover:bg-red-600 border-red-700 font-semibold">
      <AlertTriangle className="w-3 h-3 mr-1" /> En retard
    </Badge>
  );
}

export const SLA_HOURS = { critique: 4, haute: 24, normale: 72, faible: 168 };

export const STATUT_RECLAMATION = [
  "nouvelle", "assignee", "en_traitement", "en_attente_client", "validee", "resolue", "fermee", "rejetee",
];
export const STATUT_DOSSIER = [
  "enregistrement", "affectation", "traitement", "validation", "cloture", "rejete",
];
export const STATUT_APPEL = ["nouveau", "en_cours", "termine"];
export const PRIORITES = ["critique", "haute", "normale", "faible"];
export const CATEGORIES_REC = ["pension", "cotisation", "prestations", "carte", "employeur", "technique", "autre"];
export const CANAUX = ["telephone", "email", "courrier", "accueil", "web", "whatsapp", "reseaux_sociaux", "autre"];
export const LABELS_MAP = LABELS;
